import React, { useMemo, useCallback, useState, useEffect } from 'react';
// components
import { Row } from 'components/Layout/Grid';
import Table from 'components/Table';
import Input from 'components/Input';
// services
import QuoteMapProductSevices from 'services/quoteMapProduct.service';
// models
import { IRetailChain, IRetailChainChecking } from 'models/MapProduct';
// generics
import searchImg from '../../../../img/search-icon.svg';

interface IRetailChainData {
  data?: Array<IRetailChain>;
  pageSize?: number;
  total?: number;
  totalPages?: number;
  error?: boolean;
}

export default function RetailChain({
  enterpriseCode,
  selectedProduct,
  setCheckedRetails,
  setRetailPage,
}: any) {
  const pageSizeHospital = 6;
  const [currentPage, setCurrentPage] = useState(0);
  const filterHospital = `retailChain eq 'DOR'`;
  const [retailChain, setRetailChain] = useState<IRetailChainData>();
  const [updatedRetail, setUpdatedRetail] = useState<IRetailChainChecking>();
  const [filterText, setFilterText] = useState('');

  const getRetailChain = useCallback(
    async (filterHospital?: string, filterText?: any) => {
      const result = await new QuoteMapProductSevices().getRetailChain(
        currentPage,
        pageSizeHospital,
        filterHospital,
        filterText
      );

      if (result) {
        const {
          data,
          pageSize,
          total,
          totalPages,
          error,
        }: IRetailChainData = result;
        setRetailChain({
          data,
          pageSize,
          total,
          totalPages,
          error,
        });
      }
    }, [currentPage, filterText]);  /* eslint-disable-line */

  useEffect(() => {
    getRetailChain(filterHospital);
  }, [filterHospital, getRetailChain]);

  useEffect(() => {
    setTimeout(() => {
      getRetailChain(filterHospital, filterText);
    }, 3000);
  }, [filterText]); /* eslint-disable-line */

  useEffect(() => {
    setCheckedRetails(updatedRetail);
  }, [updatedRetail]); /* eslint-disable-line */

  useEffect(() => {
    setRetailPage(currentPage);
  }, [currentPage]);  /* eslint-disable-line */

  const sendUpdate = (updateData: any) => {
    const unChecked = updateData
      ?.filter((hospital: any) => !hospital.checked)
      .map((hospital: any) => hospital.documentNumber);
    const checked = updateData
      ?.filter((hospital: any) => hospital.checked)
      .map((hospital: any) => hospital.documentNumber);

    setUpdatedRetail({
      documentNumbersUnchecked: unChecked,
      documentNumbersChecked: checked,
      referenceDocumentNumber: selectedProduct[0]?.buyerIdentifier,
      referenceHospitalProductCode: selectedProduct[0]?.code,
      enterpriseCode,
    });
  };

  const handleCheckBox = (e: any) => {
    const { value, checked } = e.target;
    const updated: any = retailChain?.data?.map((hospital: IRetailChain) => {
      if (hospital.documentNumber === value) {
        return { ...hospital, checked };
      }
      return { ...hospital };
    });

    setRetailChain({
      ...retailChain,
      data: updated,
    });

    sendUpdate(updated);
  };

  const MemoRetailChain = useMemo(
    () => (
      <Table
        showPagination
        data={retailChain?.data}
        onReload={getRetailChain}
        currentPage={currentPage}
        error={retailChain?.error}
        totalPages={retailChain?.totalPages}
        pageSize={10}
        onPageChange={setCurrentPage}
        model={[
          {
            label: '',
            key: 'checked',
            size: 40,
            maxSize: 40,
            Component: (data) => (
              <Row className="w-100">
                <Input
                  type="checkbox"
                  checked={data.checked}
                  value={data.documentNumber}
                  onChange={(e: any) => handleCheckBox(e)}
                  className="bg-white w-50"
                />
              </Row>
            ),
          },
          { label: 'Cód cliente', key: 'crmCustomerCode', maxSize: 200 },
          { label: 'Razão Social', key: 'companyName', size: 300 },
          { label: 'CNPJ', key: 'documentNumber' },
        ]}
      />
    ), [retailChain, currentPage, filterText]  /* eslint-disable-line */
  );

  return (
    <Row className="flex-column">
      <Row className="w-40 w-sm-100 mt-3 mt-sm-1 mb-4">
        <Input
          value={filterText}
          placeholder="Buscar por código do produto"
          onChange={(e: any) => setFilterText(e.target.value)}
          name="codigoProduto"
          className="bg-white w-100 quotesSearch"
          type="text"
          icon={searchImg}
        />
      </Row>
      {MemoRetailChain}
    </Row>
  );
}
